import * as React from "react";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import RowActionMenu from "./row-action-menu";
export const EVENT_PROCEDURES_LIST_ID = "eventProceduresList";
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    sortable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING"
  }
];
export const useListElements = () => {
  var _a;
  const { pluggableAttributes } = usePluggableEntityTableElements(
    null,
    "event_procedure"
  );
  const attributes = ((_a = pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) == null ? void 0 : _a[0]) ? ["title", "description", pluggableAttributes.attributeNames[0]] : ["title", "description"];
  return {
    defaultLayout: {
      entityTableId: EVENT_PROCEDURES_LIST_ID,
      defaultPageSize: 20,
      defaultSort: { attributeId: "title", direction: "asc" },
      defaultDisplayedAttributes: attributes,
      defaultColumnOrder: attributes
    }
  };
};
export const useDeserializeEventProcedures = () => {
  const { pluggableAttributes } = usePluggableEntityTableElements(
    null,
    "event_procedure"
  );
  return ({ page, per_page, total, count, event_procedures }) => ({
    attributes: ATTRIBUTES,
    list: (pluggableAttributes == null ? void 0 : pluggableAttributes.attributeNames) ? event_procedures.map((procedure) => ({
      ...procedure,
      collections: 0
    })) : event_procedures,
    pagination: { total, page, per_page, count }
  });
};
export const entityActionRender = (procedure) => /* @__PURE__ */ React.createElement(RowActionMenu, { eventProcedure: procedure });
